

















































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { required } from 'vuelidate/lib/validators';
import DropdownLight from '@/shared/dropdown-light/dropdown-light.vue';

@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
  },
  validations: {
    dataCenter: { required },
  },
})
export default class SelectDataCenter extends SwExtendedVue {
  @Prop()
  showDataCenterDialog: boolean;
  dataCenter: string = '';
  @Prop()
  dcOptions: any[];
  @Prop()
  dcFlag: boolean;
  @Prop()
  tenantChangeDC: boolean;
  submitted: boolean = false;
  errorMessage: string = '';
  closeDialog() {
    console.warn('request');
    if (this.dcFlag) {
      this.$emit('closeDCDialog');
    } else if (this.tenantChangeDC) {
      this.$emit('closeTenantChangeDialog');
    } else {
      this.$emit('closeDialog');
    }
  }
  created() {
    this.dataCenter = this.dcOptions[0].id;
    console.warn(this.dataCenter);
    console.warn(this.tenantChangeDC);
  }
  validateForm() {
    this.submitted = true;
    this.errorMessage = '';
    this.$v.$touch();
    if (this.$v.$invalid) {
    } else {
      if (this.dcFlag) {
        this.$emit('closeDCDialog', { datacenter: this.dataCenter });
      } else if (this.tenantChangeDC) {
        this.$emit('closeTenantChangeDialog', { datacenter: this.dataCenter });
      } else {
        this.$emit('closeDialog', { datacenter: this.dataCenter });
      }
    }
  }
  setDC(dc: string) {
    this.dataCenter = dc;
    this.errorMessage = '';
  }
}
